namespace $.$$ {

	export class $shm_hitalama_map_widget_float_code_textarea extends $.$shm_hitalama_map_widget_float_code_textarea {

		@ $mol_mem
		revealed( next = false ) { return next }

		reveal_pending() { return this.lazy_enabled() && !this.revealed() }

		sub() {
			return !this.lazy_enabled() || this.revealed() ? super.sub() : []
		}

		@ $mol_mem
		reveal_watch() {
			if( !this.lazy_enabled() || this.revealed() ) return null
			return new this.$.$shm_hitalama_map_widget_float_code_textarea_visible(
				this.dom_node(),
				()=> this.revealed( true ),
			)
		}

	}

}
